<div *ngIf="(!isTrial && activeOptimizer && !manualOptimize) || (isTrial && activeOptimizer && desktopScore >= 90)">
  <h1 class="db-move-to-10web__title">How We Achieved a 90+ PageSpeed Score</h1>
  <div class="db-move-to-10web__checklist">
    <div class="db-move-to-10web__checklist-item" *ngFor="let checklistItem of checklistItems; let i = index">
      <div class="db-move-to-10web__checklist-left">
        <span class="db-move-to-10web__checklist-item-title">{{checklistItem.text}}
          <span class="db-score-tooltip-icon" dbInfoTooltipHover
                [dbInfoTooltipHoverPosition]="checklistItem.tooltip.length < 50 ? 'bottom-left' : (i%2 === 0  ? 'bottom-left' : 'bottom-right')"
                [dbInfoTooltipHoverBody]="checklistItem.tooltip">
              <i class='db-icon db-icon-info-lined'></i>
          </span>
        </span>
      </div>
      <div class="db-move-to-10web__checklist-right"><i class="db-icon db-icon-checkbox-round"></i></div>
    </div>
  </div>
</div>

<div *ngIf="((!isTrial && activeOptimizer && !manualOptimize)
|| (isTrial && activeOptimizer && desktopScore >= 90)) && (!domains || (domains && domains.length < 2))">
  <h1 class="db-move-to-10web__title">{{'text_one.step.left' | dbText }}</h1>
  <div class="db-point-domain-body">
    <img class="db-globe-img" src="assets/images/icons/globe.svg" alt=""/>
    <p class="db-point-domain-title">{{'text_domain.empty.title' | dbText}}</p>
    <div class="db-point-domain-desc">
      <span [innerHTML]="'text_domain.empty.desc' | dbText"></span>
      <span class="db-score-tooltip-icon" dbInfoTooltipHover [dbInfoTooltipHoverPosition]="'bottom-right'"
            [dbInfoTooltipHoverBody]="'text_addDomainDesc' | dbText">
              <i class='db-icon db-icon-info-lined'></i>
      </span>
    </div>
    <a class="db-button" [routerLink]="['/websites/' + websiteId + '/domains']"><span class="db-get-started">GET STARTED</span></a>
  </div>
</div>
